import React, { forwardRef, memo, ComponentPropsWithRef } from 'react'

import InputMask from '@mona-health/react-input-mask'

import { Input } from './Input'

interface SSNNumberInputProps extends ComponentPropsWithRef<typeof Input> {
  /**
   * Whether mask prefix and placeholder should be displayed when input is empty and has no focus
   *
   * Default is false
   */
  alwaysShowMask?: boolean
}

export const SSNNumberInput = memo(
  forwardRef<HTMLInputElement, SSNNumberInputProps>(
    ({ disabled, ...rest }, ref) => (
      <Input
        {...rest}
        {...{
          autoComplete: 'off',
          as: InputMask,
          disabled,
          mask: !disabled ? '999-99-9999' : '',
          maskPlaceholder: null,
          ref,
        }}
      />
    ),
  ),
)
